import type {
  TenantBillingStatus,
  BillingChargeStatus,
  BankTransferDisplayStatus,
} from '@kawai/shared';
import type { ChipTone } from '@kawai/ui';

// S-137: v2 の Chip 色（docs/UI-GUIDE.md「状態の色」）。良い = success / 注意・処理中 = warning /
// 進行中の段階 = brand / 終了・未開始 = neutral。悪い側（失敗・滞納）は面を作らないルールだが、
// 一覧の状態チップは面が無いと行の中で消えるので warning の面で示す（tenant-portal HomePage と同じ判断）。
// BillingPage（TP-22/23）/ BillingDetailPage（TP-25）/ BankTransferBillingPage（TP-27）で共有し、色マップの重複を避ける。

/** billingStatus の Chip 色。 */
export function billingStatusChipTone(status: TenantBillingStatus): ChipTone {
  switch (status) {
    case 'active':
      return 'success';
    case 'card_pending':
    case 'card_registered':
    case 'initial_paid':
      return 'brand';
    case 'initial_charging':
    case 'subscription_starting':
    case 'initial_failed':
    case 'past_due':
    case 'suspended':
      return 'warning';
    case 'none':
    case 'canceled':
      return 'neutral';
  }
}

/** 請求ステータス（保留 / 成功 / 失敗 / 返金）の Chip 色。 */
export function chargeStatusChipTone(status: BillingChargeStatus): ChipTone {
  switch (status) {
    case 'succeeded':
      return 'success';
    case 'pending':
    case 'failed':
      return 'warning';
    case 'refunded':
      return 'neutral';
  }
}

/** TP-27: 振込請求の表示ステータスの Chip 色。 */
export function bankTransferStatusChipTone(status: BankTransferDisplayStatus): ChipTone {
  switch (status) {
    case 'paid':
      return 'success';
    case 'invoiced':
      return 'brand';
    case 'overdue':
      return 'warning';
    case 'canceled':
    case 'refunded':
      return 'neutral';
  }
}
